import React, { Component, createRef } from 'react';
//import img2 from '../../assets/images/googleMap.png';
import img2 from '../../assets/images/Traffic.png'
import { apiEndpoint } from 'helpers/url_helper';
import { Table } from "reactstrap";
import Blink from "react-blink-text";

class MapContainer extends Component {
    constructor(props) {
        super(props);
        this.mapRef = createRef();
        this.state = {
            collection: [],
            activeMarker: null,
            showingInfoWindow: false,
            selectedPlace: null,
            status: '',
            cpuTemp: '',
            cpuUsage: '',
            RamPer: '',
            UsagePer: '',
            LastUpadtedTime: '',
            mapBounds: {
                latMin: 10.0, //  southernmost latitude
                latMax: 48.9, // northernmost latitude
                lngMin: 67.5, //  westernmost longitude
                lngMax: 77.9, //  easternmost longitude
            },
        };
    }

    componentDidMount() {
        this.fetchLocationData(this.props.CampusID);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.CampusID !== this.props.CampusID) {
            this.fetchLocationData(this.props.CampusID);
        }
    }

    fetchLocationData = (intCampusID) => {
        if (!intCampusID) return; // Prevent fetching if CampusID is undefined

        const url = apiEndpoint + '/GetLocationList';
        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                intCampusID,
                strToken: sessionStorage.getItem('Clear_AuthUser'),
            }),
        })
            .then((res) => res.json())
            .then((result) => {
                60, 60
                //const locations = JSON.parse(result.Locations || '[]');
                const locations = JSON.parse(result.Locations || '[]').map((loc, index) => ({
                    ...loc,
                    manualX: [67, 66, 62, 56, 57.3, 58, 60, 60.3, 62, 63, 61, 68.5, 61.3,66][index],
                    manualY: [75, 73, 82, 55, 52, 48.5, 60, 13, 55, 33, 64, 75, 13,67][index],
                }));
                this.setState({ collection: locations });
            })
            .catch((error) => console.error('Error fetching locations:', error));
    };

    calculatePosition = (lat, lng) => {
        const { latMin, latMax, lngMin, lngMax } = this.state.mapBounds;
        const x = ((lng - lngMin) / (lngMax - lngMin)) * 100;
        const y = ((latMax - lat) / (latMax - latMin)) * 100;
        return { x, y };
    };

    onMarkerClick = (marker) => {
        const { x, y } = this.calculatePosition(marker.Latitude, marker.Longitude);

        this.setState({
            activeMarker: { ...marker, x, y },
            showingInfoWindow: true,
            selectedPlace: marker.LocationName,
            status: '',
            cpuTemp: '',
            cpuUsage: '',
            RamPer: '',
            UsagePer: '',
            LastUpadtedTime: ''
        });
        const url = apiEndpoint + '/GetLocationData';
        fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                intLocationID: marker.LocationID,
                strToken: sessionStorage.getItem('Clear_AuthUser'),
            }),
        })
            .then((res) => res.json())
            .then((result) => {
                //const data = JSON.parse(result.LocationDetails);
                const data = typeof result.LocationDetails === "string"
                    ? JSON.parse(result.LocationDetails)
                    : result.LocationDetails;
                console.log("Fetched Location Data:", data); // Debugging log

                //const status = data.status === "Online"
                //    ? <Blink color="green" fontSize="10" text="Online"></Blink>
                //    : <Blink color="red" fontSize="10" text="Offline"></Blink>;
                debugger;
                this.setState({

                    selectedPlace: data.LocationName,
                    status: data.status,
                    cpuTemp: data.CPUTemperature + "°C",
                    cpuUsage: data.CPUUsage + "%",
                    RamPer: data.RamPerc + "%",
                    UsagePer: data.DiskUsagePerc + "%",
                    LastUpadtedTime: new Date(data.TimeStamp).toLocaleString(undefined, {
                        timeZone: 'Asia/Kolkata',
                    }),
                    //status: status,
                });
            })
            .catch((error) => console.error(error));
    };
    closeInfoWindow = () => {
        this.setState({
            showingInfoWindow: false,
            activeMarker: null,
        });
    };

    renderMarkers = () => {
        return this.state.collection.map((marker, index) => {
            //const { x, y } = this.calculatePosition(marker.Latitude, marker.Longitude);
            const x = marker.manualX ?? this.calculatePosition(marker.Latitude, marker.Longitude).x;
            const y = marker.manualY ?? this.calculatePosition(marker.Latitude, marker.Longitude).y;
            const isActive = this.state.activeMarker?.LocationID === marker.LocationID;
            return (
                <React.Fragment key={index}>
                    <div

                        style={{
                            position: 'absolute',
                            left: `${x}%`,
                            top: `${y}%`,
                            width: '30px',
                            height: '30px',
                            backgroundImage: `url(${marker.Status === 'Online'
                                ? 'https://www.pngplay.com/wp-content/uploads/5/Video-Chat-Camera-Green-Icon-PNG.png'
                                : 'https://media.giphy.com/media/4mML4cVNOKVakSy649/giphy.gif'
                                })`,
                            backgroundSize: 'contain',
                            backgroundRepeat: 'no-repeat',
                            transform: 'translate(-50%, -50%)',
                            cursor: 'pointer',
                        }}
                        title={marker.LocationName}
                        onClick={() => this.onMarkerClick(marker)}
                    ></div>

                    {isActive && this.state.showingInfoWindow && (
                        <div
                            style={{
                                position: 'absolute',
                                left: `${x}%`,
                                top: `${y}%`,
                                transform: 'translate(-50%, -120%)',
                                backgroundColor: '#fff',
                                padding: '10px',
                                border: '1px solid #ccc',
                                borderRadius: '5px',
                                zIndex: 10,
                                minWidth: '200px'
                                //zIndex: 1000,
                            }}
                        >
                            {/* Arrow Pointer */}
                            <div
                                style={{
                                    position: "absolute",
                                    bottom: "-10px",
                                    left: "49%",
                                    transform: "translateX(-50%)",
                                    width: 0,
                                    height: 0,
                                    borderLeft: "10px solid transparent",
                                    borderRight: "10px solid transparent",
                                    borderTop: "10px solid  #ffb3b3",
                                }}
                            />
                            <span
                                onClick={this.closeInfoWindow}
                                style={{
                                    position: "absolute",
                                    top: "5px",
                                    right: "5px",
                                    fontSize: "20px",
                                    fontWeight: "bold",
                                    color: "black",
                                    cursor: "pointer",
                                }}
                            >
                                &times;
                            </span>
                            <div className="table-responsive">
                                <Table className="table mb-0">
                                    <thead>
                                        <tr>
                                            <th style={{ fontSize: "10px" }}>{this.state.selectedPlace}</th>
                                            <th>
                                                {this.state.status === "Online" ? (
                                                    <Blink color="green" fontSize="10" text="Online"></Blink>
                                                ) : (
                                                    <Blink color="red" fontSize="10" text="Offline"></Blink>
                                                )}
                                            </th>
                                            <td style={{ fontSize: "smaller" }}>Last Updated: {this.state.LastUpadtedTime}</td>
                                        </tr>
                                    </thead>
                                </Table>
                                <Table className="table mb-0">
                                    <tbody>
                                        <tr className="table-danger">
                                            <td>CPU Temp</td>
                                            <td>CPU Usage</td>
                                            <td>RAM Used</td>
                                            <td>Disk Usage</td>
                                        </tr>
                                        <tr className="table-light">
                                            <td>{this.state.cpuTemp}</td>
                                            <td>{this.state.cpuUsage}</td>
                                            <td>{this.state.RamPer}</td>
                                            <td>{this.state.UsagePer}</td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    )}
                </React.Fragment>
            );
        });
    };


    render() {
        return (
            <div style={{ position: 'relative', width: '100%', height: '100%' }}>
                <img
                    src={img2}
                    alt="Static Map"
                    ref={this.mapRef}
                    style={{ width: '100%', height: '100%' }}
                />
                {this.renderMarkers()}
                {/*{this.renderInfoWindow()}*/}
            </div>
        );
    }
}

export default MapContainer;
